import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ForgetPasswordService } from '../../../Services/Password/forget-password.service';
import { NotificationService } from '../../../Services/notification.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule, CommonModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit {

  router = inject(Router);
  formBuilder = inject(FormBuilder);
  forgotPasswordForm!: FormGroup;
  isLoading: boolean = false;

  constructor(
    private forgotPasswordService: ForgetPasswordService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.initForgotPasswordForm();
  }

  initForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  verifyOTP() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const email = this.forgotPasswordForm.get('email')?.value;
    this.isLoading = true;

    this.forgotPasswordService.forgotPassword({ email }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.notificationService.showSuccess(response?.message || 'OTP sent successfully!', 'Success');
        localStorage.setItem('reset_email', email);
        this.router.navigate(['verify-otp'], { state: { email } });
      },
      error: (err) => {
        this.isLoading = false;
        this.notificationService.showError(
          err?.error?.message || 'Failed to send OTP. Please check your email.',
          'Error'
        );
      }
    });
  }
}

